function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 24.5,
  r: 23,
  stroke: "currentColor",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 21.5,
  r: 3.5,
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 21.5,
  r: 3.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2407 33.094C15.7019 33.2152 15.3633 33.7503 15.4845 34.2891C15.6057 34.8279 16.1407 35.1665 16.6795 35.0453L16.2407 33.094ZM31.4209 31.9633C31.9671 31.8816 32.3436 31.3725 32.2619 30.8263C32.1801 30.2801 31.6711 29.9036 31.1249 29.9853L31.4209 31.9633ZM16.6795 35.0453C20.8392 34.1097 27.6184 32.5325 31.4209 31.9633L31.1249 29.9853C27.2288 30.5685 20.3454 32.1708 16.2407 33.094L16.6795 35.0453Z",
  fill: "currentColor"
});

function SvgSmiley2Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley2Icon);
export default __webpack_public_path__ + "static/media/Smiley2Icon.ab82108f.svg";
export { ForwardRef as ReactComponent };